module.exports = __webpack_public_path__ + "img/img-3.05fc7c62.jpg";